import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CorporateButton } from "./../CorporateButton";
import { Title } from "./../Typography";
import { useRouter } from "next/router";
import { MediaLibraryItem } from "../../generated/graphql";
import { MobileDownloadIcon } from "../Icons/icons";
import { FileInfo } from "./FileInfo";
import { ModalBottomComp, ModalContainer, ModalContent, ModalContentAudio, ModalContentImage, ModalContentVideo } from "./styles";



export const MediaLibraryModal = ({ modalItem, closeHandler }: { modalItem: MediaLibraryItem, closeHandler: any }) => {
  const router = useRouter();

  const modalMimeType = modalItem?.assetComponent?.asset[0].mimeType;
  const modalItemIsVideo = modalMimeType?.substring(0, 5) === 'video';
  const modalItemIsAudio = modalMimeType?.substring(0, 5) === 'audio';

  let Content = <ModalContentImage><img src={modalItem?.assetComponent?.asset[0].url}
    alt={modalItem?.assetComponent?.asset[0].altText || ''} /></ModalContentImage>;

  if (modalItemIsAudio) {
    Content = <ModalContentAudio>
      <audio
        controls
        title={modalItem?.assetComponent?.asset[0].altText || ''}
        src={modalItem?.assetComponent?.asset[0].url}>
        Your browser does not support the
        <code>audio</code> element.
      </audio>
    </ModalContentAudio>;
  } else if (modalItemIsVideo) {
    Content = <ModalContentVideo>
      <video controls
        title={modalItem.assetComponent?.asset[0].altText || ''}>
        <source src={modalItem?.assetComponent?.asset[0].url}
          type={modalMimeType} />
        This browser does not support the HTML5 video element.
      </video>
    </ModalContentVideo >;
  }

  const onCloseClick = () => {
    closeHandler();
  };

  return <ModalContainer>
    <ModalContent>
      <button className="mb-2 self-end" onClick={onCloseClick}>
        <FontAwesomeIcon icon={faTimes} size="2x" />
      </button>
      {Content}
      <ModalBottomComp>
        <div>
          <FileInfo {...modalItem.assetComponent?.asset[0]} />
          <Title type="xxxs" tag="p">{modalItem.title}</Title>
        </div>
        <a href={modalItem.assetComponent?.asset[0].url}
          download={modalItem.assetComponent?.asset[0].fileName}
          target="_blank"
          rel="noreferrer">
          <CorporateButton
            color="tertiary"
            type="lead"
            icon={<MobileDownloadIcon />}
          /></a>
      </ModalBottomComp>
    </ModalContent>
  </ModalContainer>
}
